<template>
  <div class="main-promo" :class="classes">
    <picture>
      <source type="image/webp" srcset="~@/assets/images/kragi-logo2.webp" />
      <img
        class="main-promo__img"
        src="~@/assets/images/kragi-logo2.png"
        alt="Шлем и краги"
      />
    </picture>
    <div class="container">
      <!-- <MainTagline /> -->
      <!-- <div class="main-promo__title">
        <span>Red Bull</span><br/>Шлем и Краги 2022
      </div> -->

      <div class="main-promo__date">
        12 Февраля - 6 Марта 2022
      </div>
    </div>
  </div>
</template>

<script>
// import MainTagline from "./MainTagline";

export default {
  name: "MainPromo",
  components: {
    // MainTagline
  },
  computed: {
    isSmall() {
      return this.$route.name !== "home";
    },
    classes() {
      return {
        "main-promo_small": this.isSmall
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".main-promo";

.main-promo {
  margin: 0 0 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 120px;

  &__img {
    width: 500px;
    /* height: 257px; */
    filter: drop-shadow(0 6px 7px rgba(#1f6f90, 0.6))
      drop-shadow(0 10px 27px rgba(#1f6f90, 0.6))
      drop-shadow(0 33px 79px rgba(#1f6f90, 0.6));
  }

  &_small {
    /* padding-top: 70px; */
    /* margin-bottom: -16px; */
    #{$p}__img {
      width: 350px;
    }

    #{$p}__title {
      margin: 30px auto 0px auto;
    }
  }

  .container {
    text-align: center;
    color: #fff;
  }

  &__title {
    margin: 80px auto 20px auto;
    font-size: 60px;
    line-height: 65px;
    text-transform: uppercase;
    font-weight: fw(bold);

    filter: drop-shadow(0px 4px 6px rgba(#042333, 0.8))
      drop-shadow(0px 4px 6px rgba(#042333, 0.8));

    span {
      color: #dd0641;
    }
  }

  &__date {
    margin: 0 auto;
    font-size: 28px;
    line-height: 60px;
    filter: drop-shadow(0px 4px 6px rgba(#042333, 0.8))
      drop-shadow(0px 4px 6px rgba(#042333, 0.8));
  }

  @include breakpoint("lg-and-down") {
    &__img,
    &_small #{$p}__img {
      width: 350px;
    }

    &__title,
    &_small #{$p}__title {
      margin: 30px auto 0px auto;
    }
  }

  @include breakpoint("md-and-down") {
    padding-top: 100px;
  }

  @include breakpoint("sm-and-down") {
    &__img,
    &_small #{$p}__img {
      width: 220px;
    }

    &__title,
    &_small #{$p}__title {
      font-size: 40px;
      line-height: 50px;
      margin-top: 10px;
    }

    &__date {
      font-size: 20px;
      line-height: 30px;
    }
  }

  @include breakpoint("xs-only") {
    &__title,
    &_small #{$p}__title {
      font-size: 30px;
      line-height: 35px;
      margin-top: 10px;
    }

    &__date {
      font-size: 18px;
    }
  }
}
</style>
